/**
 * Swipe icon - pointing hand with left/right arrows `<- ->`, for "drag to rotate" hint.
 * Uses `currentColor`.
 */
export function Swipe({
	className,
	width = '1em',
	height = '1em',
	...rest
}) {
	return (
		<svg
      id="icon-swipe"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill="none"
			stroke="currentColor"
			aria-hidden="true"
			strokeWidth="1px"
			strokeMiterlimit="10"
			strokeLinecap="round"
			className={className}
			{...rest}
		>
			<path 
				d="M11.05,22.5,5.91,17.36a2,2,0,0,1-.59-1.43,2,2,0,0,1,2-2,2,2,0,0,1,1.43.59l1.32,1.32V6.38a2,2,0,0,1,1.74-2,1.89,1.89,0,0,1,1.52.56,1.87,1.87,0,0,1,.56,1.34V12l5,.72a1.91,1.91,0,0,1,1.64,1.89h0a17.18,17.18,0,0,1-1.82,7.71l-.09.18" />
			<polyline 
				points="19.64 7.23 22.5 4.36 19.64 1.5" />
			<line 
				x1="15.82" y1="4.36" x2="22.5" y2="4.36" />
			<polyline 
				points="4.36 7.23 1.5 4.36 4.36 1.5" />
			<line 
				x1="8.18" y1="4.36" x2="1.5" y2="4.36" />
		</svg>
	);
}